<div formGroupName="extractionconditionInfo">
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
        <mat-expansion-panel-header class="mat-panel-header-text">
            <mat-panel-title #searchTitle>検索条件</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
                <mat-form-field appearance="outline"
                    class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>未精算発生年月日（開始）</mat-label>
                    <input matInput [matDatepicker]="start" formControlName="kinkoOccurymdStart" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                    <mat-datepicker #start></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline"
                    class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>未精算発生年月日（終了）</mat-label>
                    <input matInput [matDatepicker]="end" formControlName="kinkoOccurymdEnd" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                    <mat-datepicker #end></mat-datepicker>
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
                <mat-form-field appearance="outline"
                    class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>支払契約番号</mat-label>
                    <input matInput ng-pattern="/^[0-9a-zA-Z]+$/" minlength="10" maxlength="10"
                        formControlName="payCtrNo" autocomplete="off" />
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
                <mat-form-field appearance="outline"
                    class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>入金番号</mat-label>
                    <input matInput ng-pattern="/^[0-9a-zA-Z]+$/" minlength="15" maxlength="15"
                        formControlName="rcvmnyNo" autocomplete="off" />
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
                <mat-form-field appearance="outline"
                    class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>入金形態</mat-label>
                    <mat-select formControlName="rcvmnyKeitaiCode" (valueChange)="onChangeRcvmnyKeitai($event)"
                        class="disabled-select-color">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let type of rcvmnyKeitaiList"[value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline"
                    class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>入金機関</mat-label>
                    <mat-select formControlName="rcvmnyFcltCode" class="disabled-select-color">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let type of indrctRecptFcltList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
                <mat-form-field appearance="outline"
                    class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[90%]"
                    floatLabel="always">
                    <mat-label>未精算ステータス</mat-label>
                    <input matInput style="display: none!important" formControlName="kinkoStatuscode">
                    <mat-selection-list formControlName="kinkoStatuscode" class="tw-flex tw-flex-row tw-flex-wrap"
                        style="display: flex;">
                        <mat-list-option *ngFor="let status of codeMap?.get('S300280')" [value]="status.userCode"
                            class="mat-list-option" color="primary" checkboxPosition="before">
                            {{status.hyojiCont}}
                        </mat-list-option>
                    </mat-selection-list>
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center  box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
                <mat-form-field appearance="outline"
                    class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>未精算理由</mat-label>
                    <mat-select formControlName="kinkoReasonCode" autocomplete="off">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let type of codeMap?.get('C00970A')"
                            [value]="type.userCode">{{type.hyojiCont}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="submit" mat-raised-button color="primary" class="btn"
                    [disabled]="extractionconditionInfo.invalid">検索</button>
            </mat-action-row>
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()"
                    [disabled]="!touched">クリア</button>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</div>